import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "./api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("foodgo_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await client.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("foodgo_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("foodgo_token");
    setUser(null);
  };

  const loginWithToken = (token, userData) => {
    localStorage.setItem("foodgo_token", token);
    setUser(userData);
  };

  return (
    <AuthContext.Provider value={{ user, loading, refresh: checkAuth, setUser, logout, loginWithToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
